module.exports = __webpack_public_path__ + "static/media/blossomsAndLeafs.2d3ed704.jpg";